// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__36wuh","content":"LayoutSettings_content__2bHPh"};